module.exports = "<i ng-show=\"$ctrl.tooltip && !$ctrl.haveError\"  class=\"tooltip tooltip-info\" >\r\n    <img src=\"/local/templates/moetp/assets/images/icon-info.svg\" alt=\"info\">\r\n</i>\r\n<i  ng-show=\"$ctrl.haveError&&$ctrl.__errorMessage\" class=\"tooltip tooltip-error\" >\r\n    <img src=\"/local/templates/moetp/assets/images/icon-error.svg\" alt=\"info\">\r\n</i>"


//////////////////
// WEBPACK FOOTER
// ./src/components/elements/html/tooltip.html
// module id = 168
// module chunks = 1